import { APICore } from "./apiCore";

const api = new APICore()

function listStaffProfiles(params:any): any{
    const baseUrl = "/staff-profiles"
    return api.get(baseUrl,params)
}


export {listStaffProfiles}
